import { createSlice } from '@reduxjs/toolkit';
import { FirebaseAuth } from '../../../../../../adapters/provider';
import { IActionPayload, IError } from '../../../../../../redux/types';
import { initialAdapterState, initialState } from './initialState';
import { getUserAttributes, getUserDetails } from './thunks';
import { IUser } from './types';

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        logoutUser(state, action: IActionPayload<IError | undefined | null>) {
            state.userData = { ...initialState.userData, error: action.payload ?? null };
            state.userAttributes = initialState.userAttributes;
            FirebaseAuth.signOut();
        },
        setUserData(state, action: IActionPayload<IUser>) {
            state.userData.data = action.payload;
            state.userData.error = null;
        },
        resetUserData(state) {
            state.userData = { ...initialAdapterState };
            state.userAttributes = { ...initialAdapterState };
        }
    },
    extraReducers: {
        [getUserDetails.pending.toString()]: (state) => {
            state.userData.loading = true;
            state.userData.error = null;
            state.userData.data = null;
        },
        [getUserDetails.fulfilled.toString()]: (state, { payload }) => {
            state.userData.data = payload.data;
            state.userData.loading = false;
            state.userData.error = null;
        },
        [getUserDetails.rejected.toString()]: (state, { error }) => {
            state.userData.loading = false;
            state.userData.data = null;
            state.userData.error = error;
        },
        [getUserAttributes.pending.toString()]: (state) => {
            state.userAttributes.loading = true;
            state.userAttributes.error = null;
        },
        [getUserAttributes.fulfilled.toString()]: (state, { payload }) => {
            state.userAttributes.data = payload;
            state.userAttributes.loading = false;
            state.userAttributes.error = null;
        },
        [getUserAttributes.rejected.toString()]: (state, { error }) => {
            state.userAttributes.loading = false;
            state.userAttributes.data = null;
            state.userAttributes.error = error;
        },
        'common/cleanup': (state) => {
            state.userData = { ...initialAdapterState };
            state.userAttributes = { ...initialAdapterState };
        }
    }
});
// actions
export const { resetUserData, setUserData, logoutUser } = userSlice.actions;
// thunks
export { getUserDetails };
export default userSlice.reducer;
